import { CompanyInit } from "@/components/layouts/company-init";
import { MainLayout } from "@/components/layouts/main-layout";
import Navbar from "@/components/shared/app-navigation/navbar";
import { Outlet, createFileRoute, useMatches } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/$company/unternehmen")({
  component: CompanyLayout,
});

function CompanyLayout() {
  const matches = useMatches();
  const currentRoute = matches[matches.length - 1];

  const hasCustomLayout = matches.some((match) =>
    match.routeId.includes("/unternehmen/_"),
  );

  if (hasCustomLayout) {
    return <Outlet />;
  }

  const location =
    (currentRoute?.staticData as { breadcrumb?: string[] })?.breadcrumb ?? [];

  return (
    <MainLayout>
      <CompanyInit>
        <div className="flex flex-col h-full w-full gap-4">
          <div className="flex flex-col">
            <div className="flex flex-row items-center py-1">
              <div className="flex-1">
                <Navbar location={location} />
              </div>
            </div>
          </div>
          <div className="flex-1">
            <Outlet />
          </div>
        </div>
      </CompanyInit>
    </MainLayout>
  );
}
